import React, { useState } from "react";
import PopUp from "../utils/PopUp";
import axios from "axios";
import { toast } from "sonner";

const HReport = ({ isVisible, onClose, id_user }) => {
    const [report, setReport] = useState("")
    const [type, setType] = useState("")
    const handleSubmit = async(e) => {
      e.preventDefault()

        try {
            const api = `${process.env.REACT_APP_SERVER}/api/report/create`
            const data = {
                report,
                type,
                id_user
            }
            const query = await axios.post(api,data)
            toast.success("Success create report!")
            setTimeout(() => {
              
              window.location.reload()
            }, 300);

        } catch (error) {
            console.error("ERROR: ", error)
            toast.error("Failed create report!")
        }
    }

  return (
    <PopUp isVisible={isVisible} onClose={onClose} title={"Report"}>
        <input
        onChange={(e) => {
          setReport(e.target.value)}}
          className="input mt-4 input-bordered w-full"
          type="text"
          placeholder="Report"
          value={report}
        ></input>
        <div className="flex gap-4 mt-4 justify-between ">
          <select value={type} onChange={(e) => setType(e.target.value)} className="select select-bordered w-full">
            <option value={""} disabled>
              Type of report
            </option>
            <option value={"Facility"}>Facility</option>
            <option value={"Social"}>Social</option>
            <option value={"Missing"}>Missing</option>
            <option value={"Another"}>Another</option>
          </select>
          <div className="flex justify-center items-center bottom-0">
            <button
            onClick={handleSubmit}
              className="px-3 py-2 bg-red-600 text-white rounded-lg"
            >
              Submit
            </button>
          </div>
        </div>
    </PopUp>
  );
};

export default HReport;
